<template>
  <Modal v-model="model" :title="title" sticky reset-drag-position @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="insert_edit_pop"  width="800">
    <div class="input_style insert_edit_right">
      <div class="font_style_set"><span style="color: red">*</span>标题:</div>
      <div class="insert_edit_input">
        <Input style="width: 40%" v-model="tittle" placeholder="请输入标题" />
      </div>
    </div>
    <div class="input_style insert_edit_right">
      <div class="font_style_set"><span style="color: red">*</span>内容:</div>
      <div class="insert_edit_input">
        <Input v-model="content" placeholder="请输入知识内容" type="textarea"  :autosize="{minRows: 5,maxRows: 10}" class="config_content"/>
      </div>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "PersonKnowPop",
    mixins:[publicFunClass],
    props: {
      openPersonKnowPop:Boolean,
      personId:String,
    },
    data(){
      return {
        tittle:'',
        title:'添加个人知识',
        content:'',
        model:false,
        spinShow:true,
        selected:true,
        showMessage:false,
        modelHeight:{'maxHeight':'','marginTop':'20px'},
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
      }
    },
    methods:{
      cancel:function(){
        this.$emit("closePersonKnowPop",false);
      },
      save:function(){
        let that=this;
        let param={
          id:this.personId,
          tittle:this.tittle,
          content:this.content,
          isOpen:'1',
          journalType:"知识库管理==>知识库总览==>添加个人知识库",
          menuId:"null"
        };
        this.$http.post("knowledge/doPersonalSave.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.$Message.info("操作成功");
          that.$emit("closePersonKnowPop",true);
        });
      },
      initSearch:function (id) {
        let param={
          id:id,
          type:'1',
          remark:'0',
          journalType:"null",
          menuId:"null",
        };
        let that=this;
        this.$http.post("knowledge/selectOne.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          let list =res.data.obj;
          that.tittle = list.tittle;
          that.content = list.content;
        });
      },
    },
    watch:{
      openPersonKnowPop:function () {
        this.model=this.openPersonKnowPop;
        this.title="添加个人知识";
        if(this.personId!=null && this.personId!=""){
          this.title="编辑个人知识";
          this.initSearch(this.personId);
        }
        this.tittle='';
        this.content='';
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/knowledgeBase/PersonKnowPop.vue